// extracted by mini-css-extract-plugin
module.exports = {"bodyContent":"App_bodyContent__3Dmq4","ms-Stack-inner":"App_ms-Stack-inner__3OznK","root":"App_root__2KmdL","tooManyLoginsBanner":"App_tooManyLoginsBanner__3ZXyN"};